"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReconstructAbilityHandler = exports.ReconstructActorAbilityFactory = exports.ReconstructAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
const Random_1 = require("../../utils/Random");
class ReconstructAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Reconstruct;
        this.__typeName = "Reconstruct";
    }
}
exports.ReconstructAbilityArgs = ReconstructAbilityArgs;
let ReconstructActorAbilityFactory = class ReconstructActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Reconstruct", "AllAllies", 0);
    }
};
ReconstructActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Reconstruct")
], ReconstructActorAbilityFactory);
exports.ReconstructActorAbilityFactory = ReconstructActorAbilityFactory;
let ReconstructAbilityHandler = class ReconstructAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                sequence = sequence.pushSequence("parallel");
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    const withers = container.getEffectsOfType(targetId, EffectType_1.EffectType.Withering)
                        .map(eid => container.getEffect(eid));
                    const regens = withers.map(w => ({
                        duration: w.duration,
                        witherId: w.id,
                        effect: new core_1.RegenerationEffectArgs(ability.args.__typeName, container.getPercentOfMaxHealth(targetId, Math.max(1, w.args.power)))
                    }));
                    container.applyProjectiles({
                        sequence,
                        projectiles: regens.map(() => ({
                            creatorId: ability.invokerId,
                            targetId,
                            type: "ArcaneArrow",
                            path: "line",
                            jitter: (0, Random_1.random)(3, 10)
                        })),
                        onProjectile: (sequence, _projectile, i) => {
                            const { duration, effect, witherId } = regens[i];
                            container.applyBuff({
                                sequence,
                                creatorId: ability.invokerId,
                                targetId,
                                duration,
                                effect,
                                onApplied: sequence => container.cancelEffect(sequence, witherId)
                            });
                        },
                    });
                });
            }
        });
    }
};
ReconstructAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Reconstruct)
], ReconstructAbilityHandler);
exports.ReconstructAbilityHandler = ReconstructAbilityHandler;
